import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import RealmSync from './RealmSync';
import { KEYCLOAK_ALLOWED_REALMS } from '../modules/config';
import { buildRealmPath } from '../shared/routing';

// Faengt Alt-Links/Bookmarks ohne (oder mit falsch platziertem) Realm-Praefix ab,
// z.B. "/TreeComponent" oder "/DataobjectsList/Billetest" (Realm hinten statt vorne).
// In diesen Faellen ist das ":realm"-Segment kein bekannter Realm, sondern
// tatsaechlich der Beginn eines Seitenpfads - wir leiten auf den bekannten
// Realm (falls vorhanden) um, statt die Seite falsch zu rendern.
const RealmLayout = () => {
    const { realm: urlRealm } = useParams();
    const knownRealm = useSelector((state) => state.theRealm);
    const location = useLocation();

    if (!KEYCLOAK_ALLOWED_REALMS.includes(urlRealm)) {
        if (knownRealm) {
            return <Navigate to={buildRealmPath(knownRealm, location.pathname)} replace />;
        }
        return <Navigate to="/" replace />;
    }

    return (
        <>
            <RealmSync />
            <Outlet />
        </>
    );
};

export default RealmLayout;
